export default {
	field: 'Field',
	oldValue: 'Old',
	newValue: 'New',
	intable: 'in table',
	verbs: {
		INSERT: 'created new',
		UPDATE: 'updated',
		DELETE: 'deleted',
	},
	tables: {
		risks: 'Base Risks',
		risk_meta: 'Risks',
		documents: 'Documents',
		urls: 'URLs',
	},
	fields: {
		risks: {
			code: 'Code',
			name: 'Name',
			description: 'Description',
			catalog_id: 'Catalog',
			is_custom: 'Custom',
		},
		risk_meta: {
			responsible: 'Responsible Person',
			instance_id: 'Organization',
			confidentiality: 'Confidentiality',
			integrity: 'Integrity',
			availability: 'Availability',
			accepted_residual_risk: 'Acceptable Residual Risk',
			comment: 'Comment',
			probability: 'Probability',
			impact: 'Impact',
			score: 'Risk Score',
			residual: 'Residual Risk',
			treatment: 'Treatment',
			due_date: 'Due Date',
			catalog_meta_id: 'Catalog',
			category_meta_id: 'Category',
			last_review: 'Last Review',
		},
		documents: {
			name: 'Name',
			path: 'Location',
			length: 'Size',
			content: 'Content',
			instance_id: 'Organization',
			author_id: 'Author',
		},
		urls: {
			path: 'Location',
			instance_id: 'Organization',
			author_id: 'Author',
			url: 'URL',
		},
	},
}
